import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const KnowledgeAndDisclaimer = () => {
  return (
    <>
      {/* Knowledge Section */}
      <Box component="section" className="knowledge-section section-wrap" sx={{ py: 6 }}>
        <Container maxWidth="md" sx={{ textAlign: 'center' }}>
          <Typography variant="h4" className="section-heading knowledge-title" gutterBottom>
            Update Your Legal Knowledge
          </Typography>
          <Typography
            variant="body1"
            className="section-text knowledge-text"
            sx={{ maxWidth: 900, mx: 'auto', color: 'var(--text-color)' }}
          >
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
            scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into
            electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of
            Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like
            Aldus PageMaker including versions of Lorem Ipsum.
          </Typography>
        </Container>
      </Box>

      {/* Disclaimer Section */}
      <Box
        component="section"
        className="disclaimer-section section-wrap"
        sx={{ py: 6, backgroundColor: 'var(--secondary-color)' }}
      >
        <Container maxWidth="md" sx={{ textAlign: 'center' }}>
          <Typography variant="h4" className="section-heading disclaimer-title" gutterBottom>
            Legal Disclaimer
          </Typography>
          <Typography
            variant="body1"
            className="section-text disclaimer-text"
            sx={{ color: 'var(--text-color)' }}
          >
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
            scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into
            electronic typesetting, remaining essentially unchanged.
          </Typography>
        </Container>
      </Box>
    </>
  );
};

export default KnowledgeAndDisclaimer;
